export default __webpack_public_path__ + "d843bcb43c8fa038c71cc7b9b6a8c873.png";